export default class DemonstrationBaseController {
  /**
   * 分页查询示范基地列表
   * @param {Object} sender - 发送器对象
   * @param {Object} params - 请求参数
   * @param {Object} axiosOption - axios配置
   * @param {Object} httpOption - HTTP配置
   * @returns {Promise} - 请求结果
   */
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/demonstrationBase/list', 'post', params, axiosOption, httpOption);
  }

  /**
   * 查看示范基地详情
   * @param {Object} sender - 发送器对象
   * @param {Object} params - 请求参数
   * @param {Object} axiosOption - axios配置
   * @param {Object} httpOption - HTTP配置
   * @returns {Promise} - 请求结果
   */
  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/demonstrationBase/view', 'get', params, axiosOption, httpOption);
  }

  /**
   * 添加示范基地
   * @param {Object} sender - 发送器对象
   * @param {Object} params - 请求参数
   * @param {Object} axiosOption - axios配置
   * @param {Object} httpOption - HTTP配置
   * @returns {Promise} - 请求结果
   */
  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/demonstrationBase/add', 'post', params, axiosOption, httpOption);
  }

  /**
   * 更新示范基地
   * @param {Object} sender - 发送器对象
   * @param {Object} params - 请求参数
   * @param {Object} axiosOption - axios配置
   * @param {Object} httpOption - HTTP配置
   * @returns {Promise} - 请求结果
   */
  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/demonstrationBase/update', 'post', params, axiosOption, httpOption);
  }

  /**
   * 删除示范基地
   * @param {Object} sender - 发送器对象
   * @param {Object} params - 请求参数
   * @param {Object} axiosOption - axios配置
   * @param {Object} httpOption - HTTP配置
   * @returns {Promise} - 请求结果
   */
  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/demonstrationBase/delete', 'post', params, axiosOption, httpOption);
  }

  /**
   * 导入示范基地数据
   * @param {Object} sender - 发送器对象
   * @param {Object} params - 请求参数（包含FormData）
   * @param {Object} axiosOption - axios配置
   * @param {Object} httpOption - HTTP配置
   * @returns {Promise} - 请求结果
   */
  static importData (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/demonstrationBase/import', 'post', params, axiosOption, httpOption);
  }
}
